import React from 'react';
import { useStore } from '../store/useStore';
import styles from './PageStub.module.css';

export default function ProjectHome() {
  const { project } = useStore();

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <div className={styles.icon}>
          <TowerCraneIcon />
        </div>
        <h2 className={styles.title}>{project?.name || 'Project Home'}</h2>
        <p className={styles.sub}>Overview and activity feed coming soon.</p>
      </div>
    </div>
  );
}

const TowerCraneIcon = () => (
  // viewBox 88×83 at 132×125px keeps the same 1.5px/unit ratio as before,
  // so the bucket (same unit coords) renders at identical pixel size.
  // All crane coords are ×2 → crane appears 100% larger.
  <svg width="132" height="125" viewBox="0 0 88 83" fill="none">

    {/* ── Crane (all coords ×2) ── */}
    <line x1="32" y1="12" x2="32" y2="72" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M18 78 L32 72 L46 78" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="16" y1="78" x2="48" y2="78" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="32" y1="20" x2="82" y2="20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="32" y1="20" x2="12" y2="20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="32" y1="12" x2="82" y2="20" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round"/>
    <line x1="32" y1="12" x2="12" y2="20" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round"/>
    <rect x="8"  y="16" width="9"  height="8" rx="1.2" fill="currentColor"/>
    <rect x="58" y="18" width="10" height="6" rx="1.2" fill="currentColor"/>

    {/* ── Hoist rope ── */}
    <line x1="63" y1="24" x2="63" y2="34" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>

    {/* ── Concrete bucket (same unit size as original) ── */}
    <path d="M59 36 L59 34 L61 34 L61 36" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" fill="none"/>
    <path d="M67 36 L67 34 L65 34 L65 36" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" fill="none"/>
    <rect x="58" y="36" width="10" height="11.5" stroke="currentColor" strokeWidth="1.4" fill="none"/>
    <line x1="58" y1="40.5" x2="68" y2="40.5" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round"/>
    <line x1="58" y1="40.5" x2="61" y2="47.5" stroke="currentColor" strokeWidth="1"   strokeLinecap="round"/>
    <line x1="68" y1="40.5" x2="65" y2="47.5" stroke="currentColor" strokeWidth="1"   strokeLinecap="round"/>
    <line x1="63" y1="44"   x2="63" y2="47.5" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round"/>
  </svg>
);
